import React, { useEffect, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Knoppie from './Knoppie';
import SearchBar from './SearchBar';
import ButtonGrid from './ButtonGrid';
import List from './List';
import Thumb from './Thumb';
import NoImage from '../images/no-image.png';
import useAuth from '../hooks/useAuth';
import { usePayratesListFetch } from '../hooks/usePayratesListFetch';

const PayratesList = () => {
  const auth = useAuth();
  const location = useLocation();
  const from = location.state?.from || "./";
  const { payratestate, payrateloading, payrateerror,payratesearchValue, payratesetSearchValue, payratesetIncludeInactive, fetchPayratesList } = usePayratesListFetch();
  const observer = useRef();

  console.log(payratestate)
  const lastStockItemRef = useCallback(
    
    
    (node) => {
      console.log("total pages = "+payratestate.total_pages +" and page is " + payratestate.page)
      if (payrateloading || payratestate.payrates.length >= payratestate.total_results) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          fetchPayratesList(payratestate.page,payratesearchValue);
        }
      });
      if (node) observer.current.observe(node);
    },
    [payrateloading, fetchPayratesList, payratestate.page]
  );

  const username = auth.auth.user.username;
  const access = auth.auth.user.userRole;

  return (
    <>
      <Header username={username} role={access} destination={from} />

      {access === "administrator" && (
        <Knoppie destination={`/addNewStockitem`} text={'Add new Payrate'} clickable={true} from={'../PayratesList'} />
      )}

      <div className='ListHead'>
        <SearchBar key={1} setSearchValue={payratesetSearchValue} />
        <div>Stock Items {payratestate.payrates.length}/{payratestate.total_results}</div>
        <ButtonGrid>
          <Knoppie
            text={'Show All'}
            clickable={true}
            dropdown={true}
            switchOn={true}
            callback={() => payratesetIncludeInactive(true)}
          />
          <Knoppie
            text={'Show Active Only'}
            clickable={true}
            dropdown={true}
            switchOn={false}
            callback={() => payratesetIncludeInactive(false)}
          />
          

        </ButtonGrid>
      </div>

      {payrateerror && <div>Error loading stock items</div>}

      <List  destination={''}>
        <div className='PayrateLineitem'>
        <div>code</div>
        <div>Hours</div>
        <div>Rate</div>
        <div>Total</div>
        <div>actions</div>
        </div>
        {payratestate.payrates.length > 0 ? (
          payratestate.payrates.map((item, index) => (
            <div className='PayrateLineitem' key={item._id} ref={index === payratestate.payrates.length - 1 ? lastStockItemRef : null}>
              
              <div>{item.code}</div>
              <div>{item.hours}</div>
              <div>{item.rate}</div>
              <div>{item.total}</div>
             

              {access === "administrator" && (
                <Knoppie text={"Delete"} clickable={true} callback={() => console.log("Delete", item._id)} />
              )}
              
              
         
            </div>
          ))
        ) : (
          <div>No Payrates found.</div>
        )}
      </List>

      {payrateloading && <h1>Loading more items...</h1>}
    </>
  );
};

export default PayratesList;
